<label class="switch">
  <div class="inside">
    <input type="checkbox" [formControl]="form.get(controlName)" />
    <span class="slider round"></span>
  </div>
  <div class="text">{{ name }}</div>
</label>
